module.exports = __webpack_public_path__ + "static/socialmedia_tech_14-2e00b88050cc63aa7d744f915a60b831.jpg";